import * as React from 'react';
import styles from './style.css';



export function Grid(props) {
    const {children} = props;
    return (
        <div className={styles.container}>
            {children}
        </div>
    )
}

export default Grid;
